const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const generateCampaignInternalCodes = queryVars => {
  return callAuthorizedGraphQLEndpoint(
    `mutation ($input: GenerateCampaignInternalCodes!) {
      generateInternalCodes(input:$input){
        campaignId
        internalCodes{
          id
          internalCode
          internalLink
          city{
            id
            name
          }
        }
      }
    }`,
    {
      input: queryVars,
    },
  )
}
